import { render } from "./modal-window.vue?vue&type=template&id=e2abf408"
import script from "./modal-window.vue?vue&type=script&lang=js"
export * from "./modal-window.vue?vue&type=script&lang=js"

import exportComponent from "D:\\solutions\\Snappii Server Side and Web Site\\_projects\\wincode\\Store2Phone_Builder\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__